<template>
  <div class="container">
    <!-- 配色方案选择和Enter按钮区域 -->
    <div class="header-controls">
      <!-- 配色方案选择按钮 -->
      <div class="color-scheme-selector">
        <button v-for="scheme in colorSchemes" :key="scheme.name"
          :class="['color-btn', { active: currentColorScheme === scheme.name }]"
          :style="{ backgroundColor: scheme.buttonColor }" @click="switchColorScheme(scheme.name)"
          :title="scheme.name"></button>
      </div>

      <!-- 手动查询按钮 -->
      <button class="manual-enter-btn" @click="queryDutyList" title="手动查询">
        Enter
      </button>
    </div>
    <!-- 退出全屏提示，仅在全屏时显示 -->
    <div v-if="isFullscreen" class="exit-tip">按Alt+F4键退出应用</div>
    <!-- 查询输入区 -->
    <div class="query-section" :style="{ marginTop: '15px' }">
      <div class="input-container">
        <div class="input-item">
          <label class="input-label">闸盒编号：</label>
          <input ref="boxCodeInput" v-model="queryParams.boxCode" class="input-field" placeholder="请输入闸盒编号"
            @blur="handleBlur" @keyup.enter="queryDutyList" />
        </div>
        <div class="input-item">
          <label class="input-label">车辆编号：</label>
          <input v-model="queryParams.busNum" class="input-field" placeholder="请输入车辆编号" @blur="handleBlur"
            @keyup.enter="queryDutyList" />
        </div>
        <div class="input-item">
          <label class="input-label">司机编号：</label>
          <input v-model="queryParams.driverNum" class="input-field" placeholder="请输入司机编号" @blur="handleBlur"
            @keyup.enter="queryDutyList" />
        </div>
      </div>
    </div>

    <!-- 错误信息显示 -->
    <div v-if="errorMessage" class="error-section">
      <div class="error-title">错误信息：</div>
      <div class="error-content">{{ errorMessage }}</div>
    </div>

    <!-- 结果显示区上方的警告提示 -->
    <div
      v-if="showResult && currentQueryParams.boxCode && !currentQueryParams.busNum && !currentQueryParams.driverNum && headerInfo.queryDateTime && isDateBeforeToday(headerInfo.queryDateTime)"
      class="warning-section">
      <div class="warning-title">重要提示：</div>
      <div class="warning-content">上次查询时间：{{ headerInfo.queryDateTime
      }}，以下信息可能已过期。可能的原因是，最近一次更换此闸盒时，投币机未检测到此闸盒。故障点可能是此闸盒，或者投币机。</div>
    </div>

    <!-- 结果显示区 -->
    <div v-if="showResult" class="result-section">
      <h2 class="result-title">驾驶员电子值勤单</h2>

      <!-- 公共信息部分：当车辆编号或司机编号有值时隐藏 -->
      <div v-if="
        !this.currentQueryParams.busNum && !this.currentQueryParams.driverNum
      " class="common-info">
        <div class="common-info-row">
          <div class="common-info-item">
            <span class="common-info-label">闸盒编号：</span>
            <span class="common-info-value">{{ headerInfo.boxCode }}</span>
          </div>
          <div class="common-info-item">
            <span class="common-info-label">运营线路：</span>
            <span class="common-info-value">{{ headerInfo.lineName }}</span>
          </div>
        </div>
        <div class="common-info-row">
          <div class="common-info-item">
            <span class="common-info-label">更换时间：</span>
            <span class="common-info-value">{{ headerInfo.onDutyTime }}</span>
          </div>
          <div class="common-info-item">
            <span class="common-info-label">车辆编号：</span>
            <span class="common-info-value">{{ headerInfo.busNum }}</span>
          </div>
        </div>
      </div>

      <!-- 卡片排列区 -->
      <div class="card-container">
        <div v-for="(item, index) in tableData" :key="index" class="duty-card">
          <!-- 卡片头部：根据查询条件显示不同信息 -->
          <div class="card-header">
            <div class="card-header-top">
              <span v-if="item.driverId === 0" class="watermark-text">系统记录(非值勤单)</span>
              <span
                v-if="currentQueryParams.boxCode && !currentQueryParams.busNum && !currentQueryParams.driverNum && item.queryDateTime && isDateBeforeToday(item.queryDateTime)"
                class="watermark-text">信息可能已过期</span>
              <span class="card-index">序号：{{ index + 1 }}</span>
              <span v-if="currentQueryParams.busNum || currentQueryParams.driverNum" class="take-out-badge">{{
                item.takeOut ? '已收胆' : '未收胆' }}</span>
            </div>
            <!-- 当车辆编号或司机编号有值时，显示详细信息 -->
            <div v-if="currentQueryParams.busNum || currentQueryParams.driverNum" class="card-header-details">
              <div class="header-detail-item">
                <span class="detail-label">闸盒：</span>
                <span class="detail-value">{{ item.boxCode }}</span>
              </div>
              <div class="header-detail-item">
                <span class="detail-label">线路：</span>
                <span class="detail-value">{{ item.lineName }}</span>
              </div>
              <div class="header-detail-item">
                <span class="detail-label">车辆：</span>
                <span class="detail-value">{{ item.busNum }}</span>
              </div>
            </div>
          </div>
          <!-- 原有卡片内容 -->
          <div class="card-content">
            <div class="card-row">
              <div class="card-item">
                <span class="card-label">工号：</span>
                <span class="card-value">{{ item.driverNum || '' }}</span>
              </div>
              <div class="card-item">
                <span class="card-label">姓名：</span>
                <span class="card-value">{{ item.driverName || '' }}</span>
              </div>
            </div>
            <div class="card-row">
              <div class="card-item">
                <span class="card-label">日期：</span>
                <span class="card-value">{{ item.date }}</span>
              </div>
              <div class="card-item">
                <span class="card-label">时间：</span>
                <span class="card-value">{{ item.time }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      companyId: '',
      queryParams: {
        boxCode: '',
        busNum: '',
        driverNum: ''
      },
      // 保存当前查询条件（用于显示逻辑判断）
      currentQueryParams: {
        boxCode: '',
        busNum: '',
        driverNum: ''
      },
      showResult: false,
      headerInfo: {
        boxCode: '',
        lineName: '',
        onDutyTime: '',
        busNum: '',
        queryDateTime: ''
      },
      tableData: [],
      errorMessage: '',
      isFocusing: false,
      isFullscreen: false,
      // 配色方案数据
      colorSchemes: [
        { name: '默认', buttonColor: '#00d4ff', variables: { '--bg-primary': '#1a1a2e', '--bg-secondary': '#16213e', '--bg-tertiary': '#0f3460', '--color-primary': '#00d4ff', '--color-secondary': '#00ff88', '--text-primary': '#ffffff', '--border-color': '#00d4ff', '--shadow-color': 'rgba(0, 212, 255, 0.2)', '--warning-bg': 'rgba(255, 77, 77, 0.1)' } },
        { name: '深蓝', buttonColor: '#42a5f5', variables: { '--bg-primary': '#1a1a2e', '--bg-secondary': '#1e2a47', '--bg-tertiary': '#2d3e6b', '--color-primary': '#42a5f5', '--color-secondary': '#64b5f6', '--text-primary': '#ffffff', '--border-color': '#42a5f5', '--shadow-color': 'rgba(66, 165, 245, 0.3)', '--warning-bg': 'rgba(255, 77, 77, 0.1)' } },
        { name: '浅蓝', buttonColor: '#64b5f6', variables: { '--bg-primary': '#f0f8ff', '--bg-secondary': '#e3f2fd', '--bg-tertiary': '#bbdefb', '--color-primary': '#42a5f5', '--color-secondary': '#2196f3', '--text-primary': '#0d47a1', '--border-color': '#64b5f6', '--shadow-color': 'rgba(100, 181, 246, 0.3)', '--warning-bg': 'rgba(255, 77, 77, 0.1)' } },
        { name: '浅灰', buttonColor: '#90a4ae', variables: { '--bg-primary': '#f5f5f5', '--bg-secondary': '#e0e0e0', '--bg-tertiary': '#bdbdbd', '--color-primary': '#78909c', '--color-secondary': '#607d8b', '--text-primary': '#263238', '--border-color': '#90a4ae', '--shadow-color': 'rgba(144, 164, 174, 0.3)', '--warning-bg': 'rgba(255, 77, 77, 0.1)' } },
        { name: '清新绿', buttonColor: '#81c784', variables: { '--bg-primary': '#f1f8e9', '--bg-secondary': '#e8f5e8', '--bg-tertiary': '#c8e6c9', '--color-primary': '#66bb6a', '--color-secondary': '#4caf50', '--text-primary': '#1b5e20', '--border-color': '#81c784', '--shadow-color': 'rgba(129, 199, 132, 0.3)', '--warning-bg': 'rgba(255, 77, 77, 0.1)' } },
        { name: '星空灰', buttonColor: '#6c757d', variables: { '--bg-primary': '#37474f', '--bg-secondary': '#455a64', '--bg-tertiary': '#546e7a', '--color-primary': '#90a4ae', '--color-secondary': '#b0bec5', '--text-primary': '#eceff1', '--border-color': '#6c757d', '--shadow-color': 'rgba(108, 117, 125, 0.3)', '--warning-bg': 'rgba(255, 77, 77, 0.1)' } },
        { name: '少女粉', buttonColor: '#f06292', variables: { '--bg-primary': '#fff3f7', '--bg-secondary': '#ffebee', '--bg-tertiary': '#fce4ec', '--color-primary': '#ec407a', '--color-secondary': '#e91e63', '--text-primary': '#880e4f', '--border-color': '#f06292', '--shadow-color': 'rgba(240, 98, 146, 0.3)', '--warning-bg': 'rgba(255, 77, 77, 0.1)' } }
      ],
      // 当前选择的配色方案，默认为默认
      currentColorScheme: '默认'
    };
  },
  mounted: function () {
    // 从URL获取companyId参数
    const urlParams = new URLSearchParams(window.location.search);
    this.companyId = urlParams.get('companyId') || '';
    console.log('从URL获取的companyId:', this.companyId);

    // 从本地存储读取配色方案
    this.loadColorScheme();

    // 页面加载后聚焦到闸盒编号输入框
    this.$nextTick(() => {
      this.$refs.boxCodeInput.focus();
    });

    // 初始化全屏状态检测
    console.log('初始化全屏状态检测');
    this.checkFullscreen();

    // 添加全屏变化事件监听
    const fullscreenEvents = [
      'fullscreenchange',
      'webkitfullscreenchange',
      'mozfullscreenchange',
      'msfullscreenchange'
    ];

    fullscreenEvents.forEach(event => {
      document.addEventListener(event, this.checkFullscreen);
      console.log('已添加事件监听:', event);
    });

    // 添加resize事件监听，用于检测F11全屏模式
    window.addEventListener('resize', this.checkFullscreen);
    console.log('已添加resize事件监听');
  },
  beforeUnmount: function () {
    // 清理事件监听
    const fullscreenEvents = [
      'fullscreenchange',
      'webkitfullscreenchange',
      'mozfullscreenchange',
      'msfullscreenchange'
    ];

    fullscreenEvents.forEach(event => {
      document.removeEventListener(event, this.checkFullscreen);
      console.log('已移除事件监听:', event);
    });

    // 移除resize事件监听
    window.removeEventListener('resize', this.checkFullscreen);
    console.log('已移除resize事件监听');
  },
  methods: {
    // 从本地存储加载配色方案
    loadColorScheme: function () {
      const savedScheme = localStorage.getItem('colorScheme');
      if (savedScheme && this.colorSchemes.some(scheme => scheme.name === savedScheme)) {
        this.currentColorScheme = savedScheme;
      }
      this.applyColorScheme(this.currentColorScheme);
    },

    // 切换配色方案
    switchColorScheme: function (schemeName) {
      this.currentColorScheme = schemeName;
      this.applyColorScheme(schemeName);
      localStorage.setItem('colorScheme', schemeName);
    },

    // 应用配色方案
    applyColorScheme: function (schemeName) {
      const scheme = this.colorSchemes.find(s => s.name === schemeName);
      if (scheme) {
        const root = document.documentElement;
        for (const [key, value] of Object.entries(scheme.variables)) {
          root.style.setProperty(key, value);
        }
      }
    },

    checkFullscreen: function () {
      // 方法1：检测API全屏模式
      const fullscreenElement = document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement;
      let isApiFullscreen = !!fullscreenElement;

      // 方法2：检测F11全屏模式（通过比较窗口大小与屏幕大小）
      let isF11Fullscreen = false;
      try {
        isF11Fullscreen = window.innerWidth === screen.width &&
          window.innerHeight === screen.height;
      } catch (e) {
        console.error('F11全屏检测失败:', e);
      }

      // 综合两种检测结果
      this.isFullscreen = isApiFullscreen || isF11Fullscreen;

      // 调试信息，可在浏览器控制台查看
      console.log('全屏状态检测:', this.isFullscreen,
        'API全屏:', isApiFullscreen,
        'F11全屏:', isF11Fullscreen);
    },

    // 判断日期是否早于今天
    isDateBeforeToday: function (dateStr) {
      if (!dateStr) return false;

      // 创建今天的日期对象，时间设置为00:00:00
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // 创建传入日期的对象，时间设置为00:00:00
      const date = new Date(dateStr);
      date.setHours(0, 0, 0, 0);

      // 比较日期
      return date < today;
    },
    handleBlur: function () {
      setTimeout(() => {
        if (!document.activeElement || document.activeElement.tagName !== 'INPUT') {
          this.$refs.boxCodeInput.focus();
        }
      }, 100);
    },
    queryDutyList: async function () {
      this.errorMessage = '';
      this.showResult = false;

      if (!this.queryParams.boxCode && !this.queryParams.busNum && !this.queryParams.driverNum) {
        this.errorMessage = '错误：闸盒编号、车辆编号、司机编号不能同时为空，请至少输入一个查询条件';
        return;
      }

      // 保存当前查询参数用于显示逻辑
      this.currentQueryParams = {
        boxCode: this.queryParams.boxCode,
        busNum: this.queryParams.busNum,
        driverNum: this.queryParams.driverNum
      };

      // 构建包含companyId的请求参数
      const requestParams = {
        ...this.queryParams,
        companyId: this.companyId
      };

      try {
        const response = await fetch('/api/app/iot/driverOnDuty/list', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestParams)
        });

        const result = await response.json();

        if (result.code !== 1000) {
          this.errorMessage = `查询失败：${result.message || '未知错误'}`;
          return;
        }

        this.processResultData(result.data);

        // 清空输入框，但保留currentQueryParams用于显示逻辑
        this.queryParams.boxCode = '';
        this.queryParams.busNum = '';
        this.queryParams.driverNum = '';
        this.$nextTick(() => {
          this.$refs.boxCodeInput.focus();
        });

      } catch (error) {
        this.errorMessage = `请求错误：${error.message || '网络异常'}`;
        this.queryParams.boxCode = '';
        this.queryParams.busNum = '';
        this.queryParams.driverNum = '';
        this.$nextTick(() => {
          this.$refs.boxCodeInput.focus();
        });
      }
    },
    processResultData: function (data) {
      if (!data || !Array.isArray(data) || data.length === 0) {
        this.errorMessage = '查询结果为空';
        return;
      }

      // 保留headerInfo，用于公共信息显示
      const headerRecord = data.find(item => item.driverId === 0);
      if (headerRecord) {
        this.headerInfo = {
          boxCode: headerRecord.boxCode || headerRecord.boxId || '无',
          lineName: headerRecord.lineName || '无',
          onDutyTime: headerRecord.onDutyTime || '无',
          busNum: headerRecord.busNum || '无',
          queryDateTime: headerRecord.queryDateTime || ''
        };
      }

      // 根据查询条件决定是否过滤driverId为0的记录
      // 当车辆编号或司机编号有值时，显示所有记录；否则只显示driverId不为0的记录
      let filteredData = data;
      if (!this.currentQueryParams.busNum && !this.currentQueryParams.driverNum) {
        // 只有闸盒编号有值时，过滤掉driverId为0的记录
        filteredData = data.filter(item => item.driverId !== 0);
      }

      this.tableData = filteredData
        .map(item => {
          const dateTime = item.onDutyTime || '';
          const [date, time] = dateTime.split(' ') || ['', ''];

          return {
            driverId: item.driverId,
            driverNum: item.driverNum || '无',
            driverName: item.driverName || '无',
            date: date || '无',
            time: time || '无',
            boxCode: item.boxCode || item.boxId || '无',
            lineName: item.lineName || '无',
            busNum: item.busNum || '无',
            takeOut: item.takeOut || false,
            queryDateTime: item.queryDateTime || ''
          };
        });

      this.showResult = true;
    }
  }
}
</script>

<style scoped>
/* 全局样式 */
.container {
  background-color: var(--bg-primary);
  color: var(--text-primary);
  min-height: 94.5vh;
  padding: 20px;
  font-family: 'Arial', sans-serif;
  position: relative;
  overflow: auto;
}

/* 退出全屏提示 */
.exit-tip {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 11px;
  color: var(--text-primary);
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px 5px;
  border-radius: 5px;
  opacity: 0.8;
}

/* 查询输入区 */
.query-section {
  background-color: var(--bg-secondary);
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.input-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}

.input-item {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 280px;
  flex-wrap: nowrap;
}

.input-label {
  font-size: 24px;
  margin-right: 15px;
  width: 120px;
  color: var(--color-primary);
  white-space: nowrap;
  flex-shrink: 0;
}

.input-field {
  flex: 1;
  padding: 15px;
  font-size: 24px;
  border: 2px solid var(--border-color);
  border-radius: 5px;
  background-color: var(--bg-tertiary);
  color: var(--text-primary);
  outline: none;
  transition: all 0.3s ease;
  min-width: 0;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .input-item {
    min-width: 250px;
  }

  .input-label {
    width: 100px;
    font-size: 20px;
  }

  .input-field {
    font-size: 20px;
  }
}

@media (max-width: 992px) {
  .input-item {
    min-width: 200px;
  }

  .input-label {
    width: 90px;
    font-size: 18px;
    margin-right: 10px;
  }

  .input-field {
    font-size: 18px;
    padding: 12px;
  }
}

@media (max-width: 768px) {
  .input-container {
    flex-direction: column;
    gap: 15px;
  }

  .input-item {
    min-width: 100%;
    width: 100%;
  }

  .input-label {
    width: 100px;
    font-size: 18px;
  }

  .input-field {
    font-size: 18px;
    padding: 12px;
  }
}

@media (max-width: 480px) {
  .query-section {
    padding: 15px;
  }

  .input-label {
    width: 80px;
    font-size: 16px;
    margin-right: 8px;
  }

  .input-field {
    font-size: 16px;
    padding: 10px;
  }
}

.input-field:focus {
  box-shadow: 0 0 10px var(--color-secondary);
  border-color: var(--color-secondary);
}

/* 错误信息显示 */
.error-section {
  background-color: rgba(255, 77, 77, 0.1);
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 30px;
  border: 2px solid #ff4d4d;
}

.error-title {
  font-size: 20px;
  font-weight: bold;
  color: #ff4d4d;
  margin-bottom: 10px;
}

.error-content {
  font-size: 18px;
  color: #ff6b6b;
  white-space: pre-wrap;
}

/* 警告信息显示 */
.warning-section {
  background-color: var(--warning-bg);
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 30px;
  border: 2px solid var(--color-primary);
  box-shadow: 0 0 15px var(--shadow-color);
}

.warning-title {
  font-size: 25px;
  font-weight: bold;
  color: #fa5050;
  margin-bottom: 10px;
  text-shadow: 0 0 5px var(--shadow-color);
}

.warning-content {
  font-size: 18px;
  color: #fa5050;
  white-space: pre-wrap;
  font-weight: bold;
  line-height: 1.5;
}

/* 结果显示区 */
.result-section {
  background-color: var(--bg-secondary);
  padding: 10px 20px 10px;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.result-title {
  text-align: center;
  font-size: 32px;
  margin-top: 0;
  margin-bottom: 10px;
  color: var(--color-primary);
}

/* 公共信息部分 */
.common-info {
  background-color: var(--bg-tertiary);
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  border: 2px solid var(--border-color);
  margin-left: auto;
  margin-right: auto;
}

.common-info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.common-info-row:last-child {
  margin-bottom: 0;
}

.common-info-item {
  display: flex;
  align-items: center;
  width: 48%;
  justify-content: flex-start;
  flex-wrap: nowrap;
  min-width: 250px;
  margin-bottom: 10px;
}

.common-info-item:last-child {
  margin-bottom: 0;
}

.common-info-label {
  color: var(--color-primary);
  margin-right: 15px;
  font-weight: bold;
  font-size: 24px;
  width: 100px;
  text-align: right;
  white-space: nowrap;
  flex-shrink: 0;
}

.common-info-value {
  color: var(--text-primary);
  font-weight: normal;
  font-size: 24px;
  text-align: left;
  flex: 1;
  white-space: nowrap;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 公共信息响应式设计 */
@media (max-width: 768px) {
  .common-info-row {
    flex-direction: column;
    gap: 10px;
  }

  .common-info-item {
    width: 100%;
    min-width: auto;
    margin-bottom: 0;
  }

  .common-info-label {
    width: 90px;
    font-size: 20px;
    margin-right: 10px;
  }

  .common-info-value {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .common-info {
    padding: 15px;
  }

  .common-info-label {
    width: 80px;
    font-size: 18px;
    margin-right: 8px;
  }

  .common-info-value {
    font-size: 18px;
    word-break: normal;
  }
}

/* 卡片容器 */
.card-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 20px;
}

/* 卡片样式 */
.duty-card {
  background-color: var(--bg-tertiary);
  border: 2px solid var(--border-color);
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 0 15px var(--shadow-color);
  transition: all 0.3s ease;
  min-width: 350px;
}

.duty-card:hover {
  box-shadow: 0 0 25px var(--shadow-color);
  transform: translateY(-5px);
}

/* 卡片头部 */
.card-header {
  border-bottom: 1px solid var(--border-color);
  padding: 5px 10px 2px 10px;
  margin-bottom: 7.5px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 0 0;
}

.card-header-top {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
  padding: 0 10px;
  width: 100%;
  position: relative;
}

.card-index {
  color: var(--color-primary);
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  white-space: nowrap;
  flex-shrink: 0;
  margin: 0 auto;
}

.watermark-text {
  color: #ff4d4d;
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 2px 6px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.take-out-badge {
  background-color: var(--color-primary);
  color: white;
  padding: 3px 8px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: bold;
  animation: pulse 2s infinite;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}

@keyframes pulse {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }

  100% {
    opacity: 1;
  }
}

.card-header-details {
  display: flex;
  flex-wrap: nowrap;
  gap: 15px;
  padding: 0;
  font-size: 16px;
}

.header-detail-item {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 100px;
  white-space: nowrap;
}

.detail-label {
  color: var(--color-primary);
  font-weight: bold;
  margin-right: 5px;
  font-size: 14px;
  white-space: nowrap;
}

.detail-value {
  color: var(--text-primary);
  font-size: 14px;
  font-weight: normal;
  white-space: nowrap;
}

/* 卡片内容 */
.card-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.card-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.card-item {
  display: flex;
  align-items: center;
  min-width: 150px;
  flex: 1;
}

.card-label {
  color: var(--color-primary);
  margin-right: 5px;
  font-weight: bold;
  font-size: 20px;
  white-space: nowrap;
  text-align: right;
  width: 50px;
}

.card-value {
  color: var(--text-primary);
  font-weight: normal;
  font-size: 20px;
  border-bottom: 1px solid var(--text-primary);
  padding: 0 5px;
  min-width: 100px;
  text-align: left;
  word-break: break-word;
}

/* 配色方案选择按钮样式 */
.color-scheme-selector {
  display: flex;
  gap: 8px;
}

.color-btn {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 0.7;
}

.color-btn:hover {
  opacity: 1;
  transform: scale(1.2);
}

.color-btn.active {
  opacity: 1;
  transform: scale(1.3);
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
}

/* 顶部控制区域样式 */
.header-controls {
  position: absolute;
  top: 5px;
  left: 20px;
  right: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
}

/* 手动查询按钮样式 */
.manual-enter-btn {
  padding: 0px 5px;
  background-color: var(--color-primary);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 0.8;
  white-space: nowrap;
  height: 20px;
  margin-top: 3px;
  margin-right: 10px;
}

.manual-enter-btn:hover {
  opacity: 1;
  box-shadow: 0 0 8px var(--shadow-color);
}

/* 响应式设计 */
@media (max-width: 768px) {

  /* 查询输入区响应式 */
  .input-item {
    min-width: 100%;
  }

  .input-label {
    width: 100px;
    font-size: 20px;
    margin-bottom: 10px;
  }

  .input-field {
    font-size: 20px;
  }

  /* 公共信息响应式 */
  .common-info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .common-info-label,
  .common-info-value {
    font-size: 20px;
  }

  /* 卡片容器响应式 */
  .card-container {
    grid-template-columns: 1fr;
  }

  /* 卡片内容响应式 */
  .card-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .card-label,
  .card-value {
    font-size: 18px;
  }
}
</style>